// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from "./client";
import { client } from "./client.gen";
import type {
  AdminAddGroupAppRoleData,
  AdminAddGroupAppRoleErrors,
  AdminAddGroupAppRoleResponses,
  AdminAddGroupTenantData,
  AdminAddGroupTenantErrors,
  AdminAddGroupTenantResponses,
  AdminAddPackageToProjectData,
  AdminAddPackageToProjectErrors,
  AdminAddPackageToProjectResponses,
  AdminAddProjectData,
  AdminAddProjectErrors,
  AdminAddProjectResponses,
  AdminAddProjectRoleOfUserData,
  AdminAddProjectRoleOfUserErrors,
  AdminAddProjectRoleOfUserResponses,
  AdminAddProjectToGroupData,
  AdminAddProjectToGroupErrors,
  AdminAddProjectToGroupResponses,
  AdminAddRoleToGroupData,
  AdminAddRoleToGroupErrors,
  AdminAddRoleToGroupResponses,
  AdminAddUserToGroupData,
  AdminAddUserToGroupErrors,
  AdminAddUserToGroupResponses,
  AdminAddUserToProjectData,
  AdminAddUserToProjectErrors,
  AdminAddUserToProjectResponses,
  AdminChangeGroupAppRoleData,
  AdminChangeGroupAppRoleErrors,
  AdminChangeGroupAppRoleResponses,
  AdminChangeGroupScopeTypeData,
  AdminChangeGroupScopeTypeErrors,
  AdminChangeGroupScopeTypeResponses,
  AdminChangeProjectRoleOfUserData,
  AdminChangeProjectRoleOfUserErrors,
  AdminChangeProjectRoleOfUserResponses,
  AdminChangeUserScopeTypeData,
  AdminChangeUserScopeTypeErrors,
  AdminChangeUserScopeTypeResponses,
  AdminCreateGroupData,
  AdminCreateGroupErrors,
  AdminCreateGroupResponses,
  AdminCreateUserData,
  AdminCreateUserErrors,
  AdminCreateUserResponses,
  AdminDeleteAllGroupsFromProjectData,
  AdminDeleteAllGroupsFromProjectErrors,
  AdminDeleteAllGroupsFromProjectResponses,
  AdminDeleteAllUsersFromProjectData,
  AdminDeleteAllUsersFromProjectErrors,
  AdminDeleteAllUsersFromProjectResponses,
  AdminDeleteGroupAppRoleData,
  AdminDeleteGroupAppRoleErrors,
  AdminDeleteGroupAppRoleResponses,
  AdminDeleteGroupData,
  AdminDeleteGroupErrors,
  AdminDeleteGroupFromProjectData,
  AdminDeleteGroupFromProjectErrors,
  AdminDeleteGroupFromProjectResponses,
  AdminDeleteGroupResponses,
  AdminDeleteProjectData,
  AdminDeleteProjectErrors,
  AdminDeleteProjectResponses,
  AdminDeleteUserData,
  AdminDeleteUserErrors,
  AdminDeleteUserFromProjectData,
  AdminDeleteUserFromProjectErrors,
  AdminDeleteUserFromProjectResponses,
  AdminDeleteUserResponses,
  AdminGetDomainsData,
  AdminGetDomainsErrors,
  AdminGetDomainsResponses,
  AdminGetGroupData,
  AdminGetGroupErrors,
  AdminGetGroupResponses,
  AdminGetGroupsData,
  AdminGetGroupsErrors,
  AdminGetGroupsResponses,
  AdminGetUserData,
  AdminGetUserDataData,
  AdminGetUserDataErrors,
  AdminGetUserDataResponses,
  AdminGetUserDetailsProjectsData,
  AdminGetUserDetailsProjectsErrors,
  AdminGetUserDetailsProjectsResponses,
  AdminGetUserErrors,
  AdminGetUserProjectsUpData,
  AdminGetUserProjectsUpErrors,
  AdminGetUserProjectsUpResponses,
  AdminGetUserResponses,
  AdminGetUserRolesUpData,
  AdminGetUserRolesUpErrors,
  AdminGetUserRolesUpResponses,
  AdminRemoveAdminRoleFromGroupData,
  AdminRemoveAdminRoleFromGroupErrors,
  AdminRemoveAdminRoleFromGroupResponses,
  AdminRemoveGroupTenantData,
  AdminRemoveGroupTenantErrors,
  AdminRemoveGroupTenantResponses,
  AdminRemovePackageFromProjectData,
  AdminRemovePackageFromProjectErrors,
  AdminRemovePackageFromProjectResponses,
  AdminRemoveProjectRoleOfUserData,
  AdminRemoveProjectRoleOfUserErrors,
  AdminRemoveProjectRoleOfUserResponses,
  AdminRemoveUserFromGroupData,
  AdminRemoveUserFromGroupErrors,
  AdminRemoveUserFromGroupResponses,
  AdminRemoveUserRoleData,
  AdminRemoveUserRoleErrors,
  AdminRemoveUserRoleResponses,
  AdminRequestPasswordResetData,
  AdminRequestPasswordResetErrors,
  AdminRequestPasswordResetResponses,
  AdminUpdateGroupData,
  AdminUpdateGroupErrors,
  AdminUpdateGroupResponses,
  AdminUpdateProjectData,
  AdminUpdateProjectErrors,
  AdminUpdateProjectResponses,
  AdminUpdateRoleInGroupData,
  AdminUpdateRoleInGroupErrors,
  AdminUpdateRoleInGroupResponses,
  AdminUpdateUserData,
  AdminUpdateUserErrors,
  AdminUpdateUserResponses,
  AdminUpdateUserRoleData,
  AdminUpdateUserRoleErrors,
  AdminUpdateUserRoleResponses,
  AdminUsersCreateAdminUserData,
  AdminUsersCreateAdminUserErrors,
  AdminUsersCreateAdminUserResponses,
  AdminUsersGetAdminUserData,
  AdminUsersGetAdminUserErrors,
  AdminUsersGetAdminUserResponses,
  AdminUsersGetMyAdminDataData,
  AdminUsersGetMyAdminDataErrors,
  AdminUsersGetMyAdminDataResponses,
  AdminUsersListAdminUsersData,
  AdminUsersListAdminUsersErrors,
  AdminUsersListAdminUsersResponses,
  AdminUsersRevokeAdminAccessData,
  AdminUsersRevokeAdminAccessErrors,
  AdminUsersRevokeAdminAccessResponses,
  AdminUsersUpdateAdminUserData,
  AdminUsersUpdateAdminUserErrors,
  AdminUsersUpdateAdminUserResponses,
  AuditLogsGetAuditLogData,
  AuditLogsGetAuditLogErrors,
  AuditLogsGetAuditLogResponses,
  AuditLogsListAuditLogsData,
  AuditLogsListAuditLogsErrors,
  AuditLogsListAuditLogsResponses,
  AuthzCheckAccessData,
  AuthzCheckAccessErrors,
  AuthzCheckAccessResponses,
  AuthzPermissionsData,
  AuthzPermissionsErrors,
  AuthzPermissionsResponses,
  AuthzPlanData,
  AuthzPlanErrors,
  AuthzPlanResponses,
  DomainsGetAllAppsData,
  DomainsGetAllAppsErrors,
  DomainsGetAllAppsResponses,
  EdifyPackagesGetEdifyPackagesData,
  EdifyPackagesGetEdifyPackagesErrors,
  EdifyPackagesGetEdifyPackagesResponses,
  EdifyPackagesGetProjectByPackageIdData,
  EdifyPackagesGetProjectByPackageIdErrors,
  EdifyPackagesGetProjectByPackageIdResponses,
  EdifyPackagesSearchEdifyPackagesData,
  EdifyPackagesSearchEdifyPackagesErrors,
  EdifyPackagesSearchEdifyPackagesResponses,
  GroupsAddGroupTenantData,
  GroupsAddGroupTenantErrors,
  GroupsAddGroupTenantResponses,
  GroupsAddRoleToGroupData,
  GroupsAddRoleToGroupErrors,
  GroupsAddRoleToGroupResponses,
  GroupsAddUserToGroupData,
  GroupsAddUserToGroupErrors,
  GroupsAddUserToGroupResponses,
  GroupsChangeGroupScopeTypeData,
  GroupsChangeGroupScopeTypeErrors,
  GroupsChangeGroupScopeTypeResponses,
  GroupsCreateGroupData,
  GroupsCreateGroupErrors,
  GroupsCreateGroupResponses,
  GroupsDeleteGroupData,
  GroupsDeleteGroupErrors,
  GroupsDeleteGroupResponses,
  GroupsGetGroupByIdData,
  GroupsGetGroupByIdErrors,
  GroupsGetGroupByIdResponses,
  GroupsGetGroupsData,
  GroupsGetGroupsErrors,
  GroupsGetGroupsResponses,
  GroupsRemoveGroupTenantData,
  GroupsRemoveGroupTenantErrors,
  GroupsRemoveGroupTenantResponses,
  GroupsRemoveRoleFromGroupData,
  GroupsRemoveRoleFromGroupErrors,
  GroupsRemoveRoleFromGroupResponses,
  GroupsRemoveUserFromGroupData,
  GroupsRemoveUserFromGroupErrors,
  GroupsRemoveUserFromGroupResponses,
  GroupsUpdateGroupData,
  GroupsUpdateGroupErrors,
  GroupsUpdateGroupResponses,
  GroupsUpdateRoleInGroupData,
  GroupsUpdateRoleInGroupErrors,
  GroupsUpdateRoleInGroupResponses,
  ProjectsAddPackageToProjectData,
  ProjectsAddPackageToProjectErrors,
  ProjectsAddPackageToProjectResponses,
  ProjectsAddProjectData,
  ProjectsAddProjectErrors,
  ProjectsAddProjectResponses,
  ProjectsAddProjectRoleOfUserData,
  ProjectsAddProjectRoleOfUserErrors,
  ProjectsAddProjectRoleOfUserResponses,
  ProjectsAddUserToProjectData,
  ProjectsAddUserToProjectErrors,
  ProjectsAddUserToProjectResponses,
  ProjectsBulkGetProjectsByIdsData,
  ProjectsBulkGetProjectsByIdsErrors,
  ProjectsBulkGetProjectsByIdsResponses,
  ProjectsChangeProjectRoleOfUserData,
  ProjectsChangeProjectRoleOfUserErrors,
  ProjectsChangeProjectRoleOfUserResponses,
  ProjectsDeleteGroupFromProjectData,
  ProjectsDeleteGroupFromProjectErrors,
  ProjectsDeleteGroupFromProjectResponses,
  ProjectsDeleteUserFromProjectData,
  ProjectsDeleteUserFromProjectErrors,
  ProjectsDeleteUserFromProjectResponses,
  ProjectsGetProjectByIdData,
  ProjectsGetProjectByIdErrors,
  ProjectsGetProjectByIdResponses,
  ProjectsGetProjectEntitiesData,
  ProjectsGetProjectEntitiesErrors,
  ProjectsGetProjectEntitiesResponses,
  ProjectsGetProjectPackagesData,
  ProjectsGetProjectPackagesErrors,
  ProjectsGetProjectPackagesResponses,
  ProjectsGetProjectsData,
  ProjectsGetProjectsErrors,
  ProjectsGetProjectsResponses,
  ProjectsGetProjectUsersByAppData,
  ProjectsGetProjectUsersByAppErrors,
  ProjectsGetProjectUsersByAppResponses,
  ProjectsGetProjectUsersData,
  ProjectsGetProjectUsersErrors,
  ProjectsGetProjectUsersResponses,
  ProjectsGetUserProjectRolesData,
  ProjectsGetUserProjectRolesErrors,
  ProjectsGetUserProjectRolesResponses,
  ProjectsRemovePackageFromProjectData,
  ProjectsRemovePackageFromProjectErrors,
  ProjectsRemovePackageFromProjectResponses,
  ProjectsRemoveProjectRoleOfUserData,
  ProjectsRemoveProjectRoleOfUserErrors,
  ProjectsRemoveProjectRoleOfUserResponses,
  ProjectsUpdateProjectData,
  ProjectsUpdateProjectErrors,
  ProjectsUpdateProjectResponses,
  RolesGetAllRolesData,
  RolesGetAllRolesErrors,
  RolesGetAllRolesResponses,
  ServiceApiPackagesGetProjectByPackageIdData,
  ServiceApiPackagesGetProjectByPackageIdErrors,
  ServiceApiPackagesGetProjectByPackageIdResponses,
  TenantsGetAllTenantsData,
  TenantsGetAllTenantsErrors,
  TenantsGetAllTenantsResponses,
  UsersBulkGetUsersData,
  UsersBulkGetUsersErrors,
  UsersBulkGetUsersResponses,
  UsersChangeUserScopeTypeData,
  UsersChangeUserScopeTypeErrors,
  UsersChangeUserScopeTypeResponses,
  UsersCreateUserData,
  UsersCreateUserErrors,
  UsersCreateUserResponses,
  UsersDeleteUserData,
  UsersDeleteUserErrors,
  UsersDeleteUserResponses,
  UsersGetUserByIdData,
  UsersGetUserByIdErrors,
  UsersGetUserByIdResponses,
  UsersGetUserGroupsData,
  UsersGetUserGroupsErrors,
  UsersGetUserGroupsResponses,
  UsersGetUserKeyringsData,
  UsersGetUserKeyringsErrors,
  UsersGetUserKeyringsResponses,
  UsersGetUserPackageIdsData,
  UsersGetUserPackageIdsErrors,
  UsersGetUserPackageIdsResponses,
  UsersGetUserProjectsData,
  UsersGetUserProjectsErrors,
  UsersGetUserProjectsResponses,
  UsersGetUserRolesData,
  UsersGetUserRolesErrors,
  UsersGetUserRolesResponses,
  UsersGetUsersData,
  UsersGetUsersErrors,
  UsersGetUsersResponses,
  UsersMeData,
  UsersMeErrors,
  UsersMeResponses,
  UsersRemoveUserRoleData,
  UsersRemoveUserRoleErrors,
  UsersRemoveUserRoleResponses,
  UsersRequestPasswordResetData,
  UsersRequestPasswordResetErrors,
  UsersRequestPasswordResetResponses,
  UsersSearchGraphUsersData,
  UsersSearchGraphUsersErrors,
  UsersSearchGraphUsersResponses,
  UsersSearchUdbUsersData,
  UsersSearchUdbUsersErrors,
  UsersSearchUdbUsersResponses,
  UsersUpdateUserData,
  UsersUpdateUserErrors,
  UsersUpdateUserResponses,
  UsersUpdateUserRoleData,
  UsersUpdateUserRoleErrors,
  UsersUpdateUserRoleResponses,
  V2AuthzCheckData,
  V2AuthzCheckErrors,
  V2AuthzCheckResponses,
  V2AuthzPlanData,
  V2AuthzPlanErrors,
  V2AuthzPlanResponses,
  V2GroupsListData,
  V2GroupsListErrors,
  V2GroupsListResponses,
  V2ProjectsMembersData,
  V2ProjectsMembersErrors,
  V2ProjectsMembersResponses,
  V2UsersAppProjectsData,
  V2UsersAppProjectsErrors,
  V2UsersAppProjectsResponses,
  V2UsersListData,
  V2UsersListErrors,
  V2UsersListResponses,
  V2UsersMeData,
  V2UsersMeErrors,
  V2UsersMeResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Get all projects, optionally with packages and filtered by tenantId
 */
export const projectsGetProjects = <ThrowOnError extends boolean = true>(
  options?: Options<ProjectsGetProjectsData, ThrowOnError>,
): RequestResult<ProjectsGetProjectsResponses, ProjectsGetProjectsErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    ProjectsGetProjectsResponses,
    ProjectsGetProjectsErrors,
    ThrowOnError
  >({ url: "/api/projects", ...options });

/**
 * [DEPRECATED] Add project
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use POST /api/admin/projects instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const projectsAddProject = <ThrowOnError extends boolean = true>(
  options?: Options<ProjectsAddProjectData, ThrowOnError>,
): RequestResult<ProjectsAddProjectResponses, ProjectsAddProjectErrors, ThrowOnError> =>
  (options?.client ?? client).post<
    ProjectsAddProjectResponses,
    ProjectsAddProjectErrors,
    ThrowOnError
  >({
    url: "/api/projects",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Get specific projects by IDs with packages
 */
export const projectsBulkGetProjectsByIds = <ThrowOnError extends boolean = true>(
  options?: Options<ProjectsBulkGetProjectsByIdsData, ThrowOnError>,
): RequestResult<
  ProjectsBulkGetProjectsByIdsResponses,
  ProjectsBulkGetProjectsByIdsErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    ProjectsBulkGetProjectsByIdsResponses,
    ProjectsBulkGetProjectsByIdsErrors,
    ThrowOnError
  >({
    url: "/api/projects/bulk",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Get project by ID
 */
export const projectsGetProjectById = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsGetProjectByIdData, ThrowOnError>,
): RequestResult<ProjectsGetProjectByIdResponses, ProjectsGetProjectByIdErrors, ThrowOnError> =>
  (options.client ?? client).get<
    ProjectsGetProjectByIdResponses,
    ProjectsGetProjectByIdErrors,
    ThrowOnError
  >({ url: "/api/projects/{id}", ...options });

/**
 * [DEPRECATED] Update project
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use PUT /api/admin/projects/:id instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const projectsUpdateProject = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsUpdateProjectData, ThrowOnError>,
): RequestResult<ProjectsUpdateProjectResponses, ProjectsUpdateProjectErrors, ThrowOnError> =>
  (options.client ?? client).put<
    ProjectsUpdateProjectResponses,
    ProjectsUpdateProjectErrors,
    ThrowOnError
  >({
    url: "/api/projects/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get users assigned to project
 */
export const projectsGetProjectUsers = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsGetProjectUsersData, ThrowOnError>,
): RequestResult<ProjectsGetProjectUsersResponses, ProjectsGetProjectUsersErrors, ThrowOnError> =>
  (options.client ?? client).get<
    ProjectsGetProjectUsersResponses,
    ProjectsGetProjectUsersErrors,
    ThrowOnError
  >({ url: "/api/projects/{id}/users", ...options });

/**
 * Get users assigned to project filtered by app, including role information
 */
export const projectsGetProjectUsersByApp = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsGetProjectUsersByAppData, ThrowOnError>,
): RequestResult<
  ProjectsGetProjectUsersByAppResponses,
  ProjectsGetProjectUsersByAppErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ProjectsGetProjectUsersByAppResponses,
    ProjectsGetProjectUsersByAppErrors,
    ThrowOnError
  >({ url: "/api/projects/{projectId}/apps/{appId}/users", ...options });

/**
 * Get packages in project
 */
export const projectsGetProjectPackages = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsGetProjectPackagesData, ThrowOnError>,
): RequestResult<
  ProjectsGetProjectPackagesResponses,
  ProjectsGetProjectPackagesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ProjectsGetProjectPackagesResponses,
    ProjectsGetProjectPackagesErrors,
    ThrowOnError
  >({ url: "/api/projects/{id}/packages", ...options });

/**
 * [DEPRECATED] Remove package from project
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use DELETE /api/admin/projects/:projectId/packages instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const projectsRemovePackageFromProject = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsRemovePackageFromProjectData, ThrowOnError>,
): RequestResult<
  ProjectsRemovePackageFromProjectResponses,
  ProjectsRemovePackageFromProjectErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    ProjectsRemovePackageFromProjectResponses,
    ProjectsRemovePackageFromProjectErrors,
    ThrowOnError
  >({
    url: "/api/projects/{projectId}/packages",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Add package to project (Used by Edify)
 */
export const projectsAddPackageToProject = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsAddPackageToProjectData, ThrowOnError>,
): RequestResult<
  ProjectsAddPackageToProjectResponses,
  ProjectsAddPackageToProjectErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ProjectsAddPackageToProjectResponses,
    ProjectsAddPackageToProjectErrors,
    ThrowOnError
  >({
    url: "/api/projects/{projectId}/packages",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * [DEPRECATED] Delete user from project
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use DELETE /api/admin/projects/:projectId/users instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const projectsDeleteUserFromProject = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsDeleteUserFromProjectData, ThrowOnError>,
): RequestResult<
  ProjectsDeleteUserFromProjectResponses,
  ProjectsDeleteUserFromProjectErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    ProjectsDeleteUserFromProjectResponses,
    ProjectsDeleteUserFromProjectErrors,
    ThrowOnError
  >({
    url: "/api/projects/{projectId}/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * [DEPRECATED] Add user to project
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use POST /api/admin/projects/:projectId/users instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const projectsAddUserToProject = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsAddUserToProjectData, ThrowOnError>,
): RequestResult<ProjectsAddUserToProjectResponses, ProjectsAddUserToProjectErrors, ThrowOnError> =>
  (options.client ?? client).post<
    ProjectsAddUserToProjectResponses,
    ProjectsAddUserToProjectErrors,
    ThrowOnError
  >({
    url: "/api/projects/{projectId}/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * [DEPRECATED] Delete group from project
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use DELETE /api/admin/projects/:projectId/groups instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const projectsDeleteGroupFromProject = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsDeleteGroupFromProjectData, ThrowOnError>,
): RequestResult<
  ProjectsDeleteGroupFromProjectResponses,
  ProjectsDeleteGroupFromProjectErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    ProjectsDeleteGroupFromProjectResponses,
    ProjectsDeleteGroupFromProjectErrors,
    ThrowOnError
  >({
    url: "/api/projects/{projectId}/groups",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * [DEPRECATED] Remove project role from user
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use DELETE /api/admin/projects/:projectId/users/:userId instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const projectsRemoveProjectRoleOfUser = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsRemoveProjectRoleOfUserData, ThrowOnError>,
): RequestResult<
  ProjectsRemoveProjectRoleOfUserResponses,
  ProjectsRemoveProjectRoleOfUserErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    ProjectsRemoveProjectRoleOfUserResponses,
    ProjectsRemoveProjectRoleOfUserErrors,
    ThrowOnError
  >({
    url: "/api/projects/{projectId}/users/{userId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * [DEPRECATED] Add project role to user
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use POST /api/admin/projects/:projectId/users/:userId instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const projectsAddProjectRoleOfUser = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsAddProjectRoleOfUserData, ThrowOnError>,
): RequestResult<
  ProjectsAddProjectRoleOfUserResponses,
  ProjectsAddProjectRoleOfUserErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    ProjectsAddProjectRoleOfUserResponses,
    ProjectsAddProjectRoleOfUserErrors,
    ThrowOnError
  >({
    url: "/api/projects/{projectId}/users/{userId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * [DEPRECATED] Change project role of user
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use PUT /api/admin/projects/:projectId/users/:userId instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const projectsChangeProjectRoleOfUser = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsChangeProjectRoleOfUserData, ThrowOnError>,
): RequestResult<
  ProjectsChangeProjectRoleOfUserResponses,
  ProjectsChangeProjectRoleOfUserErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    ProjectsChangeProjectRoleOfUserResponses,
    ProjectsChangeProjectRoleOfUserErrors,
    ThrowOnError
  >({
    url: "/api/projects/{projectId}/users/{userId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get user project roles by project ID
 */
export const projectsGetUserProjectRoles = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsGetUserProjectRolesData, ThrowOnError>,
): RequestResult<
  ProjectsGetUserProjectRolesResponses,
  ProjectsGetUserProjectRolesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ProjectsGetUserProjectRolesResponses,
    ProjectsGetUserProjectRolesErrors,
    ThrowOnError
  >({ url: "/api/projects/{projectId}/users/{sub}/roles", ...options });

/**
 * Get entities (users and groups) for a certain role assigned to project ID
 */
export const projectsGetProjectEntities = <ThrowOnError extends boolean = true>(
  options: Options<ProjectsGetProjectEntitiesData, ThrowOnError>,
): RequestResult<
  ProjectsGetProjectEntitiesResponses,
  ProjectsGetProjectEntitiesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ProjectsGetProjectEntitiesResponses,
    ProjectsGetProjectEntitiesErrors,
    ThrowOnError
  >({ url: "/api/projects/{projectId}/withRole/{roleName}", ...options });

/**
 * Get logged in user information
 */
export const usersMe = <ThrowOnError extends boolean = true>(
  options?: Options<UsersMeData, ThrowOnError>,
): RequestResult<UsersMeResponses, UsersMeErrors, ThrowOnError> =>
  (options?.client ?? client).get<UsersMeResponses, UsersMeErrors, ThrowOnError>({
    url: "/api/users/me",
    ...options,
  });

/**
 * Get all users
 */
export const usersGetUsers = <ThrowOnError extends boolean = true>(
  options?: Options<UsersGetUsersData, ThrowOnError>,
): RequestResult<UsersGetUsersResponses, UsersGetUsersErrors, ThrowOnError> =>
  (options?.client ?? client).get<UsersGetUsersResponses, UsersGetUsersErrors, ThrowOnError>({
    url: "/api/users",
    ...options,
  });

/**
 * [DEPRECATED] Create new user
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use POST /api/admin/users instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const usersCreateUser = <ThrowOnError extends boolean = true>(
  options?: Options<UsersCreateUserData, ThrowOnError>,
): RequestResult<UsersCreateUserResponses, UsersCreateUserErrors, ThrowOnError> =>
  (options?.client ?? client).post<UsersCreateUserResponses, UsersCreateUserErrors, ThrowOnError>({
    url: "/api/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * [DEPRECATED] Delete user
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use DELETE /api/admin/users/:sub instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const usersDeleteUser = <ThrowOnError extends boolean = true>(
  options: Options<UsersDeleteUserData, ThrowOnError>,
): RequestResult<UsersDeleteUserResponses, UsersDeleteUserErrors, ThrowOnError> =>
  (options.client ?? client).delete<UsersDeleteUserResponses, UsersDeleteUserErrors, ThrowOnError>({
    url: "/api/users/{sub}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get user by ID
 */
export const usersGetUserById = <ThrowOnError extends boolean = true>(
  options: Options<UsersGetUserByIdData, ThrowOnError>,
): RequestResult<UsersGetUserByIdResponses, UsersGetUserByIdErrors, ThrowOnError> =>
  (options.client ?? client).get<UsersGetUserByIdResponses, UsersGetUserByIdErrors, ThrowOnError>({
    url: "/api/users/{sub}",
    ...options,
  });

/**
 * [DEPRECATED] Update user
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use PUT /api/admin/users/:sub instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const usersUpdateUser = <ThrowOnError extends boolean = true>(
  options: Options<UsersUpdateUserData, ThrowOnError>,
): RequestResult<UsersUpdateUserResponses, UsersUpdateUserErrors, ThrowOnError> =>
  (options.client ?? client).put<UsersUpdateUserResponses, UsersUpdateUserErrors, ThrowOnError>({
    url: "/api/users/{sub}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * [DEPRECATED] Remove user role
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use DELETE /api/admin/users/:sub/roles instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const usersRemoveUserRole = <ThrowOnError extends boolean = true>(
  options: Options<UsersRemoveUserRoleData, ThrowOnError>,
): RequestResult<UsersRemoveUserRoleResponses, UsersRemoveUserRoleErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    UsersRemoveUserRoleResponses,
    UsersRemoveUserRoleErrors,
    ThrowOnError
  >({
    url: "/api/users/{sub}/roles",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get user roles
 */
export const usersGetUserRoles = <ThrowOnError extends boolean = true>(
  options: Options<UsersGetUserRolesData, ThrowOnError>,
): RequestResult<UsersGetUserRolesResponses, UsersGetUserRolesErrors, ThrowOnError> =>
  (options.client ?? client).get<UsersGetUserRolesResponses, UsersGetUserRolesErrors, ThrowOnError>(
    { url: "/api/users/{sub}/roles", ...options },
  );

/**
 * [DEPRECATED] Update user role
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use PUT /api/admin/users/:sub/roles instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const usersUpdateUserRole = <ThrowOnError extends boolean = true>(
  options: Options<UsersUpdateUserRoleData, ThrowOnError>,
): RequestResult<UsersUpdateUserRoleResponses, UsersUpdateUserRoleErrors, ThrowOnError> =>
  (options.client ?? client).put<
    UsersUpdateUserRoleResponses,
    UsersUpdateUserRoleErrors,
    ThrowOnError
  >({
    url: "/api/users/{sub}/roles",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get user's projects
 */
export const usersGetUserProjects = <ThrowOnError extends boolean = true>(
  options: Options<UsersGetUserProjectsData, ThrowOnError>,
): RequestResult<UsersGetUserProjectsResponses, UsersGetUserProjectsErrors, ThrowOnError> =>
  (options.client ?? client).get<
    UsersGetUserProjectsResponses,
    UsersGetUserProjectsErrors,
    ThrowOnError
  >({ url: "/api/users/{sub}/projects", ...options });

/**
 * Get user's package IDs
 */
export const usersGetUserPackageIds = <ThrowOnError extends boolean = true>(
  options: Options<UsersGetUserPackageIdsData, ThrowOnError>,
): RequestResult<UsersGetUserPackageIdsResponses, UsersGetUserPackageIdsErrors, ThrowOnError> =>
  (options.client ?? client).get<
    UsersGetUserPackageIdsResponses,
    UsersGetUserPackageIdsErrors,
    ThrowOnError
  >({ url: "/api/users/{sub}/package-ids", ...options });

/**
 * Get user's groups
 */
export const usersGetUserGroups = <ThrowOnError extends boolean = true>(
  options: Options<UsersGetUserGroupsData, ThrowOnError>,
): RequestResult<UsersGetUserGroupsResponses, UsersGetUserGroupsErrors, ThrowOnError> =>
  (options.client ?? client).get<
    UsersGetUserGroupsResponses,
    UsersGetUserGroupsErrors,
    ThrowOnError
  >({ url: "/api/users/{sub}/groups", ...options });

/**
 * Get user keyrings
 */
export const usersGetUserKeyrings = <ThrowOnError extends boolean = true>(
  options: Options<UsersGetUserKeyringsData, ThrowOnError>,
): RequestResult<UsersGetUserKeyringsResponses, UsersGetUserKeyringsErrors, ThrowOnError> =>
  (options.client ?? client).get<
    UsersGetUserKeyringsResponses,
    UsersGetUserKeyringsErrors,
    ThrowOnError
  >({ url: "/api/users/{sub}/keyrings", ...options });

/**
 * Search for users in Graph
 */
export const usersSearchGraphUsers = <ThrowOnError extends boolean = true>(
  options: Options<UsersSearchGraphUsersData, ThrowOnError>,
): RequestResult<UsersSearchGraphUsersResponses, UsersSearchGraphUsersErrors, ThrowOnError> =>
  (options.client ?? client).get<
    UsersSearchGraphUsersResponses,
    UsersSearchGraphUsersErrors,
    ThrowOnError
  >({ url: "/api/users/search/graph", ...options });

/**
 * [DEPRECATED] Request external user password reset
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use POST /api/admin/users/:sub/password-reset instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const usersRequestPasswordReset = <ThrowOnError extends boolean = true>(
  options: Options<UsersRequestPasswordResetData, ThrowOnError>,
): RequestResult<
  UsersRequestPasswordResetResponses,
  UsersRequestPasswordResetErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    UsersRequestPasswordResetResponses,
    UsersRequestPasswordResetErrors,
    ThrowOnError
  >({
    url: "/api/users/{sub}/password-reset",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Search UDB users
 */
export const usersSearchUdbUsers = <ThrowOnError extends boolean = true>(
  options: Options<UsersSearchUdbUsersData, ThrowOnError>,
): RequestResult<UsersSearchUdbUsersResponses, UsersSearchUdbUsersErrors, ThrowOnError> =>
  (options.client ?? client).get<
    UsersSearchUdbUsersResponses,
    UsersSearchUdbUsersErrors,
    ThrowOnError
  >({ url: "/api/users/search/udb", ...options });

/**
 * [DEPRECATED] Change user scope type
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use PUT /api/admin/users/:sub/scope-type instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const usersChangeUserScopeType = <ThrowOnError extends boolean = true>(
  options: Options<UsersChangeUserScopeTypeData, ThrowOnError>,
): RequestResult<UsersChangeUserScopeTypeResponses, UsersChangeUserScopeTypeErrors, ThrowOnError> =>
  (options.client ?? client).put<
    UsersChangeUserScopeTypeResponses,
    UsersChangeUserScopeTypeErrors,
    ThrowOnError
  >({
    url: "/api/users/{sub}/scope-type",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get multiple users by subs
 */
export const usersBulkGetUsers = <ThrowOnError extends boolean = true>(
  options?: Options<UsersBulkGetUsersData, ThrowOnError>,
): RequestResult<UsersBulkGetUsersResponses, UsersBulkGetUsersErrors, ThrowOnError> =>
  (options?.client ?? client).post<
    UsersBulkGetUsersResponses,
    UsersBulkGetUsersErrors,
    ThrowOnError
  >({
    url: "/api/users/bulk",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

export const tenantsGetAllTenants = <ThrowOnError extends boolean = true>(
  options?: Options<TenantsGetAllTenantsData, ThrowOnError>,
): RequestResult<TenantsGetAllTenantsResponses, TenantsGetAllTenantsErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    TenantsGetAllTenantsResponses,
    TenantsGetAllTenantsErrors,
    ThrowOnError
  >({ url: "/api/tenants", ...options });

export const domainsGetAllApps = <ThrowOnError extends boolean = true>(
  options?: Options<DomainsGetAllAppsData, ThrowOnError>,
): RequestResult<DomainsGetAllAppsResponses, DomainsGetAllAppsErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    DomainsGetAllAppsResponses,
    DomainsGetAllAppsErrors,
    ThrowOnError
  >({ url: "/api/domains", ...options });

export const rolesGetAllRoles = <ThrowOnError extends boolean = true>(
  options?: Options<RolesGetAllRolesData, ThrowOnError>,
): RequestResult<RolesGetAllRolesResponses, RolesGetAllRolesErrors, ThrowOnError> =>
  (options?.client ?? client).get<RolesGetAllRolesResponses, RolesGetAllRolesErrors, ThrowOnError>({
    url: "/api/roles",
    ...options,
  });

/**
 * Get all Edify Packages
 */
export const edifyPackagesGetEdifyPackages = <ThrowOnError extends boolean = true>(
  options?: Options<EdifyPackagesGetEdifyPackagesData, ThrowOnError>,
): RequestResult<
  EdifyPackagesGetEdifyPackagesResponses,
  EdifyPackagesGetEdifyPackagesErrors,
  ThrowOnError
> =>
  (options?.client ?? client).get<
    EdifyPackagesGetEdifyPackagesResponses,
    EdifyPackagesGetEdifyPackagesErrors,
    ThrowOnError
  >({ url: "/api/edify/packages", ...options });

/**
 * Search Edify packages with query string
 */
export const edifyPackagesSearchEdifyPackages = <ThrowOnError extends boolean = true>(
  options: Options<EdifyPackagesSearchEdifyPackagesData, ThrowOnError>,
): RequestResult<
  EdifyPackagesSearchEdifyPackagesResponses,
  EdifyPackagesSearchEdifyPackagesErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    EdifyPackagesSearchEdifyPackagesResponses,
    EdifyPackagesSearchEdifyPackagesErrors,
    ThrowOnError
  >({ url: "/api/edify/packages/packageSearch/{pageNum}", ...options });

/**
 * Get project by package id
 */
export const edifyPackagesGetProjectByPackageId = <ThrowOnError extends boolean = true>(
  options: Options<EdifyPackagesGetProjectByPackageIdData, ThrowOnError>,
): RequestResult<
  EdifyPackagesGetProjectByPackageIdResponses,
  EdifyPackagesGetProjectByPackageIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    EdifyPackagesGetProjectByPackageIdResponses,
    EdifyPackagesGetProjectByPackageIdErrors,
    ThrowOnError
  >({ url: "/api/packages/{packageId}/project", ...options });

/**
 * Get project by package id (Service-to-service endpoint)
 */
export const serviceApiPackagesGetProjectByPackageId = <ThrowOnError extends boolean = true>(
  options: Options<ServiceApiPackagesGetProjectByPackageIdData, ThrowOnError>,
): RequestResult<
  ServiceApiPackagesGetProjectByPackageIdResponses,
  ServiceApiPackagesGetProjectByPackageIdErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    ServiceApiPackagesGetProjectByPackageIdResponses,
    ServiceApiPackagesGetProjectByPackageIdErrors,
    ThrowOnError
  >({ url: "/service-api/packages/{packageId}/project", ...options });

/**
 * @deprecated
 */
export const authzCheckAccess = <ThrowOnError extends boolean = true>(
  options?: Options<AuthzCheckAccessData, ThrowOnError>,
): RequestResult<AuthzCheckAccessResponses, AuthzCheckAccessErrors, ThrowOnError> =>
  (options?.client ?? client).post<AuthzCheckAccessResponses, AuthzCheckAccessErrors, ThrowOnError>(
    {
      url: "/api/authz/check-access",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    },
  );

/**
 * @deprecated
 */
export const authzPermissions = <ThrowOnError extends boolean = true>(
  options?: Options<AuthzPermissionsData, ThrowOnError>,
): RequestResult<AuthzPermissionsResponses, AuthzPermissionsErrors, ThrowOnError> =>
  (options?.client ?? client).post<AuthzPermissionsResponses, AuthzPermissionsErrors, ThrowOnError>(
    {
      url: "/api/authz/permissions",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    },
  );

/**
 * @deprecated
 */
export const authzPlan = <ThrowOnError extends boolean = true>(
  options?: Options<AuthzPlanData, ThrowOnError>,
): RequestResult<AuthzPlanResponses, AuthzPlanErrors, ThrowOnError> =>
  (options?.client ?? client).post<AuthzPlanResponses, AuthzPlanErrors, ThrowOnError>({
    url: "/api/authz/plan",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Get all groups
 */
export const groupsGetGroups = <ThrowOnError extends boolean = true>(
  options?: Options<GroupsGetGroupsData, ThrowOnError>,
): RequestResult<GroupsGetGroupsResponses, GroupsGetGroupsErrors, ThrowOnError> =>
  (options?.client ?? client).get<GroupsGetGroupsResponses, GroupsGetGroupsErrors, ThrowOnError>({
    url: "/api/groups",
    ...options,
  });

/**
 * [DEPRECATED] Create group
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use POST /api/admin/groups instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const groupsCreateGroup = <ThrowOnError extends boolean = true>(
  options?: Options<GroupsCreateGroupData, ThrowOnError>,
): RequestResult<GroupsCreateGroupResponses, GroupsCreateGroupErrors, ThrowOnError> =>
  (options?.client ?? client).post<
    GroupsCreateGroupResponses,
    GroupsCreateGroupErrors,
    ThrowOnError
  >({
    url: "/api/groups",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * [DEPRECATED] Delete group
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use DELETE /api/admin/groups/:id instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const groupsDeleteGroup = <ThrowOnError extends boolean = true>(
  options: Options<GroupsDeleteGroupData, ThrowOnError>,
): RequestResult<GroupsDeleteGroupResponses, GroupsDeleteGroupErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    GroupsDeleteGroupResponses,
    GroupsDeleteGroupErrors,
    ThrowOnError
  >({
    url: "/api/groups/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get group by ID
 */
export const groupsGetGroupById = <ThrowOnError extends boolean = true>(
  options: Options<GroupsGetGroupByIdData, ThrowOnError>,
): RequestResult<GroupsGetGroupByIdResponses, GroupsGetGroupByIdErrors, ThrowOnError> =>
  (options.client ?? client).get<
    GroupsGetGroupByIdResponses,
    GroupsGetGroupByIdErrors,
    ThrowOnError
  >({ url: "/api/groups/{id}", ...options });

/**
 * [DEPRECATED] Update group
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use PUT /api/admin/groups/:id instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const groupsUpdateGroup = <ThrowOnError extends boolean = true>(
  options: Options<GroupsUpdateGroupData, ThrowOnError>,
): RequestResult<GroupsUpdateGroupResponses, GroupsUpdateGroupErrors, ThrowOnError> =>
  (options.client ?? client).put<GroupsUpdateGroupResponses, GroupsUpdateGroupErrors, ThrowOnError>(
    {
      url: "/api/groups/{id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options.headers,
      },
    },
  );

/**
 * [DEPRECATED] Remove tenant from group
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use DELETE /api/admin/groups/:id/tenants instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const groupsRemoveGroupTenant = <ThrowOnError extends boolean = true>(
  options: Options<GroupsRemoveGroupTenantData, ThrowOnError>,
): RequestResult<GroupsRemoveGroupTenantResponses, GroupsRemoveGroupTenantErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    GroupsRemoveGroupTenantResponses,
    GroupsRemoveGroupTenantErrors,
    ThrowOnError
  >({
    url: "/api/groups/{id}/tenants",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * [DEPRECATED] Add tenant to group
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use POST /api/admin/groups/:id/tenants instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const groupsAddGroupTenant = <ThrowOnError extends boolean = true>(
  options: Options<GroupsAddGroupTenantData, ThrowOnError>,
): RequestResult<GroupsAddGroupTenantResponses, GroupsAddGroupTenantErrors, ThrowOnError> =>
  (options.client ?? client).post<
    GroupsAddGroupTenantResponses,
    GroupsAddGroupTenantErrors,
    ThrowOnError
  >({
    url: "/api/groups/{id}/tenants",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * [DEPRECATED] Remove user from group
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use DELETE /api/admin/groups/:id/users instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const groupsRemoveUserFromGroup = <ThrowOnError extends boolean = true>(
  options: Options<GroupsRemoveUserFromGroupData, ThrowOnError>,
): RequestResult<
  GroupsRemoveUserFromGroupResponses,
  GroupsRemoveUserFromGroupErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    GroupsRemoveUserFromGroupResponses,
    GroupsRemoveUserFromGroupErrors,
    ThrowOnError
  >({
    url: "/api/groups/{id}/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * [DEPRECATED] Add user to group
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use POST /api/admin/groups/:id/users instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const groupsAddUserToGroup = <ThrowOnError extends boolean = true>(
  options: Options<GroupsAddUserToGroupData, ThrowOnError>,
): RequestResult<GroupsAddUserToGroupResponses, GroupsAddUserToGroupErrors, ThrowOnError> =>
  (options.client ?? client).post<
    GroupsAddUserToGroupResponses,
    GroupsAddUserToGroupErrors,
    ThrowOnError
  >({
    url: "/api/groups/{id}/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * [DEPRECATED] Remove role from group
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use DELETE /api/admin/groups/:id/roles instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const groupsRemoveRoleFromGroup = <ThrowOnError extends boolean = true>(
  options: Options<GroupsRemoveRoleFromGroupData, ThrowOnError>,
): RequestResult<
  GroupsRemoveRoleFromGroupResponses,
  GroupsRemoveRoleFromGroupErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    GroupsRemoveRoleFromGroupResponses,
    GroupsRemoveRoleFromGroupErrors,
    ThrowOnError
  >({
    url: "/api/groups/{id}/roles",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * [DEPRECATED] Add role to group
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use POST /api/admin/groups/:id/roles instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const groupsAddRoleToGroup = <ThrowOnError extends boolean = true>(
  options: Options<GroupsAddRoleToGroupData, ThrowOnError>,
): RequestResult<GroupsAddRoleToGroupResponses, GroupsAddRoleToGroupErrors, ThrowOnError> =>
  (options.client ?? client).post<
    GroupsAddRoleToGroupResponses,
    GroupsAddRoleToGroupErrors,
    ThrowOnError
  >({
    url: "/api/groups/{id}/roles",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * [DEPRECATED] Update role in group
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use PUT /api/admin/groups/:id/roles instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const groupsUpdateRoleInGroup = <ThrowOnError extends boolean = true>(
  options: Options<GroupsUpdateRoleInGroupData, ThrowOnError>,
): RequestResult<GroupsUpdateRoleInGroupResponses, GroupsUpdateRoleInGroupErrors, ThrowOnError> =>
  (options.client ?? client).put<
    GroupsUpdateRoleInGroupResponses,
    GroupsUpdateRoleInGroupErrors,
    ThrowOnError
  >({
    url: "/api/groups/{id}/roles",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * [DEPRECATED] Change group scope type
 *
 * **DEPRECATED**: This endpoint will be removed in v2.0.0. Please use PUT /api/admin/groups/:id/scope-type instead. Admin access required for the new endpoint.
 *
 * @deprecated
 */
export const groupsChangeGroupScopeType = <ThrowOnError extends boolean = true>(
  options: Options<GroupsChangeGroupScopeTypeData, ThrowOnError>,
): RequestResult<
  GroupsChangeGroupScopeTypeResponses,
  GroupsChangeGroupScopeTypeErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    GroupsChangeGroupScopeTypeResponses,
    GroupsChangeGroupScopeTypeErrors,
    ThrowOnError
  >({
    url: "/api/groups/{id}/scope-type",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get user roles, filtered by active roles
 */
export const adminGetUserRolesUp = <ThrowOnError extends boolean = true>(
  options: Options<AdminGetUserRolesUpData, ThrowOnError>,
): RequestResult<AdminGetUserRolesUpResponses, AdminGetUserRolesUpErrors, ThrowOnError> =>
  (options.client ?? client).get<
    AdminGetUserRolesUpResponses,
    AdminGetUserRolesUpErrors,
    ThrowOnError
  >({ url: "/api/admin/users/{userSub}/roles", ...options });

/**
 * Get user's projects, filtered by appId and only return active projects
 */
export const adminGetUserProjectsUp = <ThrowOnError extends boolean = true>(
  options: Options<AdminGetUserProjectsUpData, ThrowOnError>,
): RequestResult<AdminGetUserProjectsUpResponses, AdminGetUserProjectsUpErrors, ThrowOnError> =>
  (options.client ?? client).get<
    AdminGetUserProjectsUpResponses,
    AdminGetUserProjectsUpErrors,
    ThrowOnError
  >({ url: "/api/admin/users/{userSub}/projects", ...options });

/**
 * Get user projects for user details page
 */
export const adminGetUserDetailsProjects = <ThrowOnError extends boolean = true>(
  options: Options<AdminGetUserDetailsProjectsData, ThrowOnError>,
): RequestResult<
  AdminGetUserDetailsProjectsResponses,
  AdminGetUserDetailsProjectsErrors,
  ThrowOnError
> =>
  (options.client ?? client).get<
    AdminGetUserDetailsProjectsResponses,
    AdminGetUserDetailsProjectsErrors,
    ThrowOnError
  >({ url: "/api/admin/users/{userSub}/details", ...options });

/**
 * Get all available domains
 */
export const adminGetDomains = <ThrowOnError extends boolean = true>(
  options?: Options<AdminGetDomainsData, ThrowOnError>,
): RequestResult<AdminGetDomainsResponses, AdminGetDomainsErrors, ThrowOnError> =>
  (options?.client ?? client).get<AdminGetDomainsResponses, AdminGetDomainsErrors, ThrowOnError>({
    url: "/api/admin/domains",
    ...options,
  });

/**
 * Get all groups, optionally filtered by opco
 */
export const adminGetGroups = <ThrowOnError extends boolean = true>(
  options?: Options<AdminGetGroupsData, ThrowOnError>,
): RequestResult<AdminGetGroupsResponses, AdminGetGroupsErrors, ThrowOnError> =>
  (options?.client ?? client).get<AdminGetGroupsResponses, AdminGetGroupsErrors, ThrowOnError>({
    url: "/api/admin/groups",
    ...options,
  });

/**
 * Create group
 */
export const adminCreateGroup = <ThrowOnError extends boolean = true>(
  options?: Options<AdminCreateGroupData, ThrowOnError>,
): RequestResult<AdminCreateGroupResponses, AdminCreateGroupErrors, ThrowOnError> =>
  (options?.client ?? client).post<AdminCreateGroupResponses, AdminCreateGroupErrors, ThrowOnError>(
    {
      url: "/api/admin/groups",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    },
  );

/**
 * Delete group
 *
 * Deletes a group. Requires admin access.
 */
export const adminDeleteGroup = <ThrowOnError extends boolean = true>(
  options: Options<AdminDeleteGroupData, ThrowOnError>,
): RequestResult<AdminDeleteGroupResponses, AdminDeleteGroupErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    AdminDeleteGroupResponses,
    AdminDeleteGroupErrors,
    ThrowOnError
  >({
    url: "/api/admin/groups/{groupId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get a group by ID
 */
export const adminGetGroup = <ThrowOnError extends boolean = true>(
  options: Options<AdminGetGroupData, ThrowOnError>,
): RequestResult<AdminGetGroupResponses, AdminGetGroupErrors, ThrowOnError> =>
  (options.client ?? client).get<AdminGetGroupResponses, AdminGetGroupErrors, ThrowOnError>({
    url: "/api/admin/groups/{groupId}",
    ...options,
  });

/**
 * Update a group's name and tenants
 */
export const adminUpdateGroup = <ThrowOnError extends boolean = true>(
  options: Options<AdminUpdateGroupData, ThrowOnError>,
): RequestResult<AdminUpdateGroupResponses, AdminUpdateGroupErrors, ThrowOnError> =>
  (options.client ?? client).put<AdminUpdateGroupResponses, AdminUpdateGroupErrors, ThrowOnError>({
    url: "/api/admin/groups/{groupId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove a user from a group
 */
export const adminRemoveUserFromGroup = <ThrowOnError extends boolean = true>(
  options: Options<AdminRemoveUserFromGroupData, ThrowOnError>,
): RequestResult<AdminRemoveUserFromGroupResponses, AdminRemoveUserFromGroupErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    AdminRemoveUserFromGroupResponses,
    AdminRemoveUserFromGroupErrors,
    ThrowOnError
  >({
    url: "/api/admin/groups/{groupId}/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Add a user to a group
 */
export const adminAddUserToGroup = <ThrowOnError extends boolean = true>(
  options: Options<AdminAddUserToGroupData, ThrowOnError>,
): RequestResult<AdminAddUserToGroupResponses, AdminAddUserToGroupErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminAddUserToGroupResponses,
    AdminAddUserToGroupErrors,
    ThrowOnError
  >({
    url: "/api/admin/groups/{groupId}/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Add a project to a group, with default roles
 */
export const adminAddProjectToGroup = <ThrowOnError extends boolean = true>(
  options: Options<AdminAddProjectToGroupData, ThrowOnError>,
): RequestResult<AdminAddProjectToGroupResponses, AdminAddProjectToGroupErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminAddProjectToGroupResponses,
    AdminAddProjectToGroupErrors,
    ThrowOnError
  >({
    url: "/api/admin/groups/{groupId}/project",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Add an app role to a group
 */
export const adminAddGroupAppRole = <ThrowOnError extends boolean = true>(
  options: Options<AdminAddGroupAppRoleData, ThrowOnError>,
): RequestResult<AdminAddGroupAppRoleResponses, AdminAddGroupAppRoleErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminAddGroupAppRoleResponses,
    AdminAddGroupAppRoleErrors,
    ThrowOnError
  >({
    url: "/api/admin/groups/{groupId}/add-app-role",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Removes an app role from a group
 */
export const adminDeleteGroupAppRole = <ThrowOnError extends boolean = true>(
  options: Options<AdminDeleteGroupAppRoleData, ThrowOnError>,
): RequestResult<AdminDeleteGroupAppRoleResponses, AdminDeleteGroupAppRoleErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminDeleteGroupAppRoleResponses,
    AdminDeleteGroupAppRoleErrors,
    ThrowOnError
  >({
    url: "/api/admin/groups/{groupId}/delete-app-role",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Changes an app role from a group
 */
export const adminChangeGroupAppRole = <ThrowOnError extends boolean = true>(
  options: Options<AdminChangeGroupAppRoleData, ThrowOnError>,
): RequestResult<AdminChangeGroupAppRoleResponses, AdminChangeGroupAppRoleErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminChangeGroupAppRoleResponses,
    AdminChangeGroupAppRoleErrors,
    ThrowOnError
  >({
    url: "/api/admin/groups/{groupId}/change-app-role",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove tenant from group
 *
 * Removes a tenant from a group. Requires admin access.
 */
export const adminRemoveGroupTenant = <ThrowOnError extends boolean = true>(
  options: Options<AdminRemoveGroupTenantData, ThrowOnError>,
): RequestResult<AdminRemoveGroupTenantResponses, AdminRemoveGroupTenantErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    AdminRemoveGroupTenantResponses,
    AdminRemoveGroupTenantErrors,
    ThrowOnError
  >({
    url: "/api/admin/groups/{groupId}/tenants",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Add tenant to group
 *
 * Adds a tenant to a group. Requires admin access.
 */
export const adminAddGroupTenant = <ThrowOnError extends boolean = true>(
  options: Options<AdminAddGroupTenantData, ThrowOnError>,
): RequestResult<AdminAddGroupTenantResponses, AdminAddGroupTenantErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminAddGroupTenantResponses,
    AdminAddGroupTenantErrors,
    ThrowOnError
  >({
    url: "/api/admin/groups/{groupId}/tenants",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove role from group
 *
 * Removes a role from a group. Requires admin access.
 */
export const adminRemoveAdminRoleFromGroup = <ThrowOnError extends boolean = true>(
  options: Options<AdminRemoveAdminRoleFromGroupData, ThrowOnError>,
): RequestResult<
  AdminRemoveAdminRoleFromGroupResponses,
  AdminRemoveAdminRoleFromGroupErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    AdminRemoveAdminRoleFromGroupResponses,
    AdminRemoveAdminRoleFromGroupErrors,
    ThrowOnError
  >({
    url: "/api/admin/groups/{groupId}/roles",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Add role to group
 *
 * Adds a role to a group. Requires admin access.
 */
export const adminAddRoleToGroup = <ThrowOnError extends boolean = true>(
  options: Options<AdminAddRoleToGroupData, ThrowOnError>,
): RequestResult<AdminAddRoleToGroupResponses, AdminAddRoleToGroupErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminAddRoleToGroupResponses,
    AdminAddRoleToGroupErrors,
    ThrowOnError
  >({
    url: "/api/admin/groups/{groupId}/roles",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update role in group
 *
 * Updates a role in a group. Requires admin access.
 */
export const adminUpdateRoleInGroup = <ThrowOnError extends boolean = true>(
  options: Options<AdminUpdateRoleInGroupData, ThrowOnError>,
): RequestResult<AdminUpdateRoleInGroupResponses, AdminUpdateRoleInGroupErrors, ThrowOnError> =>
  (options.client ?? client).put<
    AdminUpdateRoleInGroupResponses,
    AdminUpdateRoleInGroupErrors,
    ThrowOnError
  >({
    url: "/api/admin/groups/{groupId}/roles",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Change group scope type
 *
 * Changes a group's scope type. Requires admin access.
 */
export const adminChangeGroupScopeType = <ThrowOnError extends boolean = true>(
  options: Options<AdminChangeGroupScopeTypeData, ThrowOnError>,
): RequestResult<
  AdminChangeGroupScopeTypeResponses,
  AdminChangeGroupScopeTypeErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    AdminChangeGroupScopeTypeResponses,
    AdminChangeGroupScopeTypeErrors,
    ThrowOnError
  >({
    url: "/api/admin/groups/{groupId}/scope-type",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get a user by ID
 */
export const adminGetUser = <ThrowOnError extends boolean = true>(
  options: Options<AdminGetUserData, ThrowOnError>,
): RequestResult<AdminGetUserResponses, AdminGetUserErrors, ThrowOnError> =>
  (options.client ?? client).get<AdminGetUserResponses, AdminGetUserErrors, ThrowOnError>({
    url: "/api/admin/users/{userSub}",
    ...options,
  });

/**
 * Get user data for user details page
 */
export const adminGetUserData = <ThrowOnError extends boolean = true>(
  options: Options<AdminGetUserDataData, ThrowOnError>,
): RequestResult<AdminGetUserDataResponses, AdminGetUserDataErrors, ThrowOnError> =>
  (options.client ?? client).get<AdminGetUserDataResponses, AdminGetUserDataErrors, ThrowOnError>({
    url: "/api/admin/users/{userSub}/data",
    ...options,
  });

/**
 * Create new user
 *
 * Creates a new user (internal or external). Requires admin access.
 */
export const adminCreateUser = <ThrowOnError extends boolean = true>(
  options?: Options<AdminCreateUserData, ThrowOnError>,
): RequestResult<AdminCreateUserResponses, AdminCreateUserErrors, ThrowOnError> =>
  (options?.client ?? client).post<AdminCreateUserResponses, AdminCreateUserErrors, ThrowOnError>({
    url: "/api/admin/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Delete user
 *
 * Deletes a user. Requires admin access.
 */
export const adminDeleteUser = <ThrowOnError extends boolean = true>(
  options: Options<AdminDeleteUserData, ThrowOnError>,
): RequestResult<AdminDeleteUserResponses, AdminDeleteUserErrors, ThrowOnError> =>
  (options.client ?? client).delete<AdminDeleteUserResponses, AdminDeleteUserErrors, ThrowOnError>({
    url: "/api/admin/users/{sub}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update user
 *
 * Updates user properties. Requires admin access.
 */
export const adminUpdateUser = <ThrowOnError extends boolean = true>(
  options: Options<AdminUpdateUserData, ThrowOnError>,
): RequestResult<AdminUpdateUserResponses, AdminUpdateUserErrors, ThrowOnError> =>
  (options.client ?? client).put<AdminUpdateUserResponses, AdminUpdateUserErrors, ThrowOnError>({
    url: "/api/admin/users/{sub}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Request external user password reset
 *
 * Requests a password reset for an external user. Requires admin access.
 */
export const adminRequestPasswordReset = <ThrowOnError extends boolean = true>(
  options: Options<AdminRequestPasswordResetData, ThrowOnError>,
): RequestResult<
  AdminRequestPasswordResetResponses,
  AdminRequestPasswordResetErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AdminRequestPasswordResetResponses,
    AdminRequestPasswordResetErrors,
    ThrowOnError
  >({
    url: "/api/admin/users/{sub}/password-reset",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove user role
 *
 * Removes a user's role. Requires admin access.
 */
export const adminRemoveUserRole = <ThrowOnError extends boolean = true>(
  options: Options<AdminRemoveUserRoleData, ThrowOnError>,
): RequestResult<AdminRemoveUserRoleResponses, AdminRemoveUserRoleErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    AdminRemoveUserRoleResponses,
    AdminRemoveUserRoleErrors,
    ThrowOnError
  >({
    url: "/api/admin/users/{sub}/roles",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update user role
 *
 * Updates a user's role. Requires admin access.
 */
export const adminUpdateUserRole = <ThrowOnError extends boolean = true>(
  options: Options<AdminUpdateUserRoleData, ThrowOnError>,
): RequestResult<AdminUpdateUserRoleResponses, AdminUpdateUserRoleErrors, ThrowOnError> =>
  (options.client ?? client).put<
    AdminUpdateUserRoleResponses,
    AdminUpdateUserRoleErrors,
    ThrowOnError
  >({
    url: "/api/admin/users/{sub}/roles",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Change user scope type
 *
 * Changes user scope type and adds default app role accordingly. Requires admin access.
 */
export const adminChangeUserScopeType = <ThrowOnError extends boolean = true>(
  options: Options<AdminChangeUserScopeTypeData, ThrowOnError>,
): RequestResult<AdminChangeUserScopeTypeResponses, AdminChangeUserScopeTypeErrors, ThrowOnError> =>
  (options.client ?? client).put<
    AdminChangeUserScopeTypeResponses,
    AdminChangeUserScopeTypeErrors,
    ThrowOnError
  >({
    url: "/api/admin/users/{sub}/scope-type",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Add project
 *
 * Creates a new project. Requires admin access.
 */
export const adminAddProject = <ThrowOnError extends boolean = true>(
  options?: Options<AdminAddProjectData, ThrowOnError>,
): RequestResult<AdminAddProjectResponses, AdminAddProjectErrors, ThrowOnError> =>
  (options?.client ?? client).post<AdminAddProjectResponses, AdminAddProjectErrors, ThrowOnError>({
    url: "/api/admin/projects",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Delete project
 *
 * Soft-deletes a project by recording a deletion timestamp. Requires admin access. Fails if the project has associated users or packages. Deleted projects are excluded from all queries and their name can be reused.
 */
export const adminDeleteProject = <ThrowOnError extends boolean = true>(
  options: Options<AdminDeleteProjectData, ThrowOnError>,
): RequestResult<AdminDeleteProjectResponses, AdminDeleteProjectErrors, ThrowOnError> =>
  (options.client ?? client).delete<
    AdminDeleteProjectResponses,
    AdminDeleteProjectErrors,
    ThrowOnError
  >({
    url: "/api/admin/projects/{projectId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Update project
 *
 * Updates project details. Requires admin access.
 */
export const adminUpdateProject = <ThrowOnError extends boolean = true>(
  options: Options<AdminUpdateProjectData, ThrowOnError>,
): RequestResult<AdminUpdateProjectResponses, AdminUpdateProjectErrors, ThrowOnError> =>
  (options.client ?? client).put<
    AdminUpdateProjectResponses,
    AdminUpdateProjectErrors,
    ThrowOnError
  >({
    url: "/api/admin/projects/{projectId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove package from project
 *
 * Removes a package from a project. Requires admin access.
 */
export const adminRemovePackageFromProject = <ThrowOnError extends boolean = true>(
  options: Options<AdminRemovePackageFromProjectData, ThrowOnError>,
): RequestResult<
  AdminRemovePackageFromProjectResponses,
  AdminRemovePackageFromProjectErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    AdminRemovePackageFromProjectResponses,
    AdminRemovePackageFromProjectErrors,
    ThrowOnError
  >({
    url: "/api/admin/projects/{projectId}/packages",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Add package to project
 *
 * Adds a package to a project. Requires admin access.
 */
export const adminAddPackageToProject = <ThrowOnError extends boolean = true>(
  options: Options<AdminAddPackageToProjectData, ThrowOnError>,
): RequestResult<AdminAddPackageToProjectResponses, AdminAddPackageToProjectErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminAddPackageToProjectResponses,
    AdminAddPackageToProjectErrors,
    ThrowOnError
  >({
    url: "/api/admin/projects/{projectId}/packages",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete user from project
 *
 * Removes a user from a project. Requires admin access.
 */
export const adminDeleteUserFromProject = <ThrowOnError extends boolean = true>(
  options: Options<AdminDeleteUserFromProjectData, ThrowOnError>,
): RequestResult<
  AdminDeleteUserFromProjectResponses,
  AdminDeleteUserFromProjectErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    AdminDeleteUserFromProjectResponses,
    AdminDeleteUserFromProjectErrors,
    ThrowOnError
  >({
    url: "/api/admin/projects/{projectId}/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Add user to project
 *
 * Adds a user to a project. Requires admin access.
 */
export const adminAddUserToProject = <ThrowOnError extends boolean = true>(
  options: Options<AdminAddUserToProjectData, ThrowOnError>,
): RequestResult<AdminAddUserToProjectResponses, AdminAddUserToProjectErrors, ThrowOnError> =>
  (options.client ?? client).post<
    AdminAddUserToProjectResponses,
    AdminAddUserToProjectErrors,
    ThrowOnError
  >({
    url: "/api/admin/projects/{projectId}/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Delete group from project
 *
 * Removes a group from a project. Requires admin access.
 */
export const adminDeleteGroupFromProject = <ThrowOnError extends boolean = true>(
  options: Options<AdminDeleteGroupFromProjectData, ThrowOnError>,
): RequestResult<
  AdminDeleteGroupFromProjectResponses,
  AdminDeleteGroupFromProjectErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    AdminDeleteGroupFromProjectResponses,
    AdminDeleteGroupFromProjectErrors,
    ThrowOnError
  >({
    url: "/api/admin/projects/{projectId}/groups",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove all users from a project
 *
 * Removes every user-role assignment scoped to the project in a single operation. Note: a user with roles in multiple apps counts as multiple removed rows. Requires admin access.
 */
export const adminDeleteAllUsersFromProject = <ThrowOnError extends boolean = true>(
  options: Options<AdminDeleteAllUsersFromProjectData, ThrowOnError>,
): RequestResult<
  AdminDeleteAllUsersFromProjectResponses,
  AdminDeleteAllUsersFromProjectErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    AdminDeleteAllUsersFromProjectResponses,
    AdminDeleteAllUsersFromProjectErrors,
    ThrowOnError
  >({
    url: "/api/admin/projects/{projectId}/users/all",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove all groups from a project
 *
 * Removes every group-role assignment scoped to the project in a single operation. Note: a group with roles in multiple apps counts as multiple removed rows. Requires admin access.
 */
export const adminDeleteAllGroupsFromProject = <ThrowOnError extends boolean = true>(
  options: Options<AdminDeleteAllGroupsFromProjectData, ThrowOnError>,
): RequestResult<
  AdminDeleteAllGroupsFromProjectResponses,
  AdminDeleteAllGroupsFromProjectErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    AdminDeleteAllGroupsFromProjectResponses,
    AdminDeleteAllGroupsFromProjectErrors,
    ThrowOnError
  >({
    url: "/api/admin/projects/{projectId}/groups/all",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Remove project role from user
 *
 * Removes a user's project role. Requires admin access.
 */
export const adminRemoveProjectRoleOfUser = <ThrowOnError extends boolean = true>(
  options: Options<AdminRemoveProjectRoleOfUserData, ThrowOnError>,
): RequestResult<
  AdminRemoveProjectRoleOfUserResponses,
  AdminRemoveProjectRoleOfUserErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    AdminRemoveProjectRoleOfUserResponses,
    AdminRemoveProjectRoleOfUserErrors,
    ThrowOnError
  >({
    url: "/api/admin/projects/{projectId}/users/{userSub}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Add project role to user
 *
 * Adds a project role to a user. Requires admin access.
 */
export const adminAddProjectRoleOfUser = <ThrowOnError extends boolean = true>(
  options: Options<AdminAddProjectRoleOfUserData, ThrowOnError>,
): RequestResult<
  AdminAddProjectRoleOfUserResponses,
  AdminAddProjectRoleOfUserErrors,
  ThrowOnError
> =>
  (options.client ?? client).post<
    AdminAddProjectRoleOfUserResponses,
    AdminAddProjectRoleOfUserErrors,
    ThrowOnError
  >({
    url: "/api/admin/projects/{projectId}/users/{userSub}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Change project role of user
 *
 * Changes a user's project role. Requires admin access.
 */
export const adminChangeProjectRoleOfUser = <ThrowOnError extends boolean = true>(
  options: Options<AdminChangeProjectRoleOfUserData, ThrowOnError>,
): RequestResult<
  AdminChangeProjectRoleOfUserResponses,
  AdminChangeProjectRoleOfUserErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    AdminChangeProjectRoleOfUserResponses,
    AdminChangeProjectRoleOfUserErrors,
    ThrowOnError
  >({
    url: "/api/admin/projects/{projectId}/users/{userSub}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Get current user's admin data
 */
export const adminUsersGetMyAdminData = <ThrowOnError extends boolean = true>(
  options?: Options<AdminUsersGetMyAdminDataData, ThrowOnError>,
): RequestResult<AdminUsersGetMyAdminDataResponses, AdminUsersGetMyAdminDataErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    AdminUsersGetMyAdminDataResponses,
    AdminUsersGetMyAdminDataErrors,
    ThrowOnError
  >({ url: "/api/admin/admin-users/me", ...options });

/**
 * List all admin users (filtered by requester scope)
 */
export const adminUsersListAdminUsers = <ThrowOnError extends boolean = true>(
  options?: Options<AdminUsersListAdminUsersData, ThrowOnError>,
): RequestResult<AdminUsersListAdminUsersResponses, AdminUsersListAdminUsersErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    AdminUsersListAdminUsersResponses,
    AdminUsersListAdminUsersErrors,
    ThrowOnError
  >({ url: "/api/admin/admin-users", ...options });

/**
 * Create admin user assignment
 */
export const adminUsersCreateAdminUser = <ThrowOnError extends boolean = true>(
  options?: Options<AdminUsersCreateAdminUserData, ThrowOnError>,
): RequestResult<
  AdminUsersCreateAdminUserResponses,
  AdminUsersCreateAdminUserErrors,
  ThrowOnError
> =>
  (options?.client ?? client).post<
    AdminUsersCreateAdminUserResponses,
    AdminUsersCreateAdminUserErrors,
    ThrowOnError
  >({
    url: "/api/admin/admin-users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Revoke admin access
 */
export const adminUsersRevokeAdminAccess = <ThrowOnError extends boolean = true>(
  options: Options<AdminUsersRevokeAdminAccessData, ThrowOnError>,
): RequestResult<
  AdminUsersRevokeAdminAccessResponses,
  AdminUsersRevokeAdminAccessErrors,
  ThrowOnError
> =>
  (options.client ?? client).delete<
    AdminUsersRevokeAdminAccessResponses,
    AdminUsersRevokeAdminAccessErrors,
    ThrowOnError
  >({ url: "/api/admin/admin-users/{userSub}", ...options });

/**
 * Get specific admin user
 */
export const adminUsersGetAdminUser = <ThrowOnError extends boolean = true>(
  options: Options<AdminUsersGetAdminUserData, ThrowOnError>,
): RequestResult<AdminUsersGetAdminUserResponses, AdminUsersGetAdminUserErrors, ThrowOnError> =>
  (options.client ?? client).get<
    AdminUsersGetAdminUserResponses,
    AdminUsersGetAdminUserErrors,
    ThrowOnError
  >({ url: "/api/admin/admin-users/{userSub}", ...options });

/**
 * Update admin user assignment
 */
export const adminUsersUpdateAdminUser = <ThrowOnError extends boolean = true>(
  options: Options<AdminUsersUpdateAdminUserData, ThrowOnError>,
): RequestResult<
  AdminUsersUpdateAdminUserResponses,
  AdminUsersUpdateAdminUserErrors,
  ThrowOnError
> =>
  (options.client ?? client).put<
    AdminUsersUpdateAdminUserResponses,
    AdminUsersUpdateAdminUserErrors,
    ThrowOnError
  >({
    url: "/api/admin/admin-users/{userSub}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * List audit logs with optional filters and pagination (super_admin only)
 */
export const auditLogsListAuditLogs = <ThrowOnError extends boolean = true>(
  options?: Options<AuditLogsListAuditLogsData, ThrowOnError>,
): RequestResult<AuditLogsListAuditLogsResponses, AuditLogsListAuditLogsErrors, ThrowOnError> =>
  (options?.client ?? client).get<
    AuditLogsListAuditLogsResponses,
    AuditLogsListAuditLogsErrors,
    ThrowOnError
  >({ url: "/api/admin/audit-logs", ...options });

/**
 * Get a single audit log entry by ID (super_admin only)
 */
export const auditLogsGetAuditLog = <ThrowOnError extends boolean = true>(
  options: Options<AuditLogsGetAuditLogData, ThrowOnError>,
): RequestResult<AuditLogsGetAuditLogResponses, AuditLogsGetAuditLogErrors, ThrowOnError> =>
  (options.client ?? client).get<
    AuditLogsGetAuditLogResponses,
    AuditLogsGetAuditLogErrors,
    ThrowOnError
  >({ url: "/api/admin/audit-logs/{id}", ...options });

/**
 * v2 identity bootstrap — who you are (not what you can do)
 */
export const v2UsersMe = <ThrowOnError extends boolean = true>(
  options?: Options<V2UsersMeData, ThrowOnError>,
): RequestResult<V2UsersMeResponses, V2UsersMeErrors, ThrowOnError> =>
  (options?.client ?? client).get<V2UsersMeResponses, V2UsersMeErrors, ThrowOnError>({
    url: "/api/v2/users/me",
    ...options,
  });

/**
 * Users in the caller's own tenant (identity only); tenant-scoped to the authenticated user
 */
export const v2UsersList = <ThrowOnError extends boolean = true>(
  options?: Options<V2UsersListData, ThrowOnError>,
): RequestResult<V2UsersListResponses, V2UsersListErrors, ThrowOnError> =>
  (options?.client ?? client).get<V2UsersListResponses, V2UsersListErrors, ThrowOnError>({
    url: "/api/v2/users",
    ...options,
  });

/**
 * Projects a user can access in an app (direct + group + opco; groups always on)
 */
export const v2UsersAppProjects = <ThrowOnError extends boolean = true>(
  options: Options<V2UsersAppProjectsData, ThrowOnError>,
): RequestResult<V2UsersAppProjectsResponses, V2UsersAppProjectsErrors, ThrowOnError> =>
  (options.client ?? client).get<
    V2UsersAppProjectsResponses,
    V2UsersAppProjectsErrors,
    ThrowOnError
  >({ url: "/api/v2/users/{sub}/apps/{appId}/projects", ...options });

/**
 * Who has access to a project in an app (users + groups; always group-aware)
 */
export const v2ProjectsMembers = <ThrowOnError extends boolean = true>(
  options: Options<V2ProjectsMembersData, ThrowOnError>,
): RequestResult<V2ProjectsMembersResponses, V2ProjectsMembersErrors, ThrowOnError> =>
  (options.client ?? client).get<V2ProjectsMembersResponses, V2ProjectsMembersErrors, ThrowOnError>(
    { url: "/api/v2/projects/{projectId}/apps/{appId}/members", ...options },
  );

/**
 * Groups in your tenant; optional ?appId&role filter (generic — never special-cases 'supplier')
 */
export const v2GroupsList = <ThrowOnError extends boolean = true>(
  options?: Options<V2GroupsListData, ThrowOnError>,
): RequestResult<V2GroupsListResponses, V2GroupsListErrors, ThrowOnError> =>
  (options?.client ?? client).get<V2GroupsListResponses, V2GroupsListErrors, ThrowOnError>({
    url: "/api/v2/groups",
    ...options,
  });

/**
 * Group-aware permission check (batch). sub is taken from the authenticated user.
 */
export const v2AuthzCheck = <ThrowOnError extends boolean = true>(
  options?: Options<V2AuthzCheckData, ThrowOnError>,
): RequestResult<V2AuthzCheckResponses, V2AuthzCheckErrors, ThrowOnError> =>
  (options?.client ?? client).post<V2AuthzCheckResponses, V2AuthzCheckErrors, ThrowOnError>({
    url: "/api/v2/authz/check",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });

/**
 * Cerbos query plan (filter) for a resource kind. sub is taken from the authenticated user.
 */
export const v2AuthzPlan = <ThrowOnError extends boolean = true>(
  options?: Options<V2AuthzPlanData, ThrowOnError>,
): RequestResult<V2AuthzPlanResponses, V2AuthzPlanErrors, ThrowOnError> =>
  (options?.client ?? client).post<V2AuthzPlanResponses, V2AuthzPlanErrors, ThrowOnError>({
    url: "/api/v2/authz/plan",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
